import { render } from "./ReservationDetails.vue?vue&type=template&id=de0d7ba4&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"

import "./ReservationDetails.vue?vue&type=style&index=0&id=de0d7ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0d7ba4"]])

export default __exports__